import axios from 'axios'
import { queryString } from '../utils'

const API_URL = process.env.VUE_APP_BASE_URL
console.log(API_URL)
const MP_V = '1.1.0'
const API_V = '1.0.5'
const APP_ID = 'wx7864765a10c83d35'
const S_VERSION = '8.5'
const SYSTEM = /android/ig.test(navigator.userAgent) ? 'android' : 'iOS'

const SUCCESS_STATUS = 200
// 业务操作成功代码
const SUCCESS = 1 // 成功
// const AUTHORIZE = 4 // 用户未授权
// const NO_BINDPHONE = 92 // 用户未绑定手机号
// const AUTHORIZE_AND_BINDPHONE = 100 // 既要授权也要绑定手机
// const ILLEAGAL_USER = 97 // 非法用户，错误的uid

function groupConsole (type, requestPayload, result) {
  if (process.env.API_DEBUG === 'true') {

    const log = console.groupCollapsed || console.group || console.log
    const route = requestPayload.url.split(API_URL)[1]
    log(route + (type === 'error' ? '请求失败' : '请求成功'))
    Object.keys(requestPayload).forEach(key => {
      console[type](key + ': ', requestPayload[key])
    })
    console[type]('result: ', result)
    console.groupEnd()
  }
}

class Fetch {
  retryCount = 0
  async retry (resp, requestPayload, resolve, reject) {
    this.retryCount++
    if (this.retryCount > 3) {
      reject(resp)
      this.retryCount = 0
      return
    }
    try {
      const res = await this.wxRequest(requestPayload)
      resolve(res)
    } catch (error) {
      reject(error)
    } finally {
      this.retryCount = 0
    }
  }
  async exec (route, params, options) {
    !options && (options = {method: 'GET', header: {}})
    const requestPayload = await this.genRequestPayload(route, params, options)
    return this.wxRequest(requestPayload)
  }
  async genRequestPayload (route, params, options) {
    // 过滤undefined参数
    Object.keys(params).forEach(key => {
      if (params[key] === undefined) delete params[key]
    })
    const isPost = options.method === 'POST'
    const data = {
      api_v: API_V,
      mp_v: MP_V,
      s_version: S_VERSION,
      system: SYSTEM,
      ...params
    }
    return {
      url: API_URL + route + (isPost ? '' : '?' + queryString(data)),
      data: isPost ? data : {},
      method: options.method,
      header: {
        'content-type': isPost ? 'application/x-www-form-urlencoded' : 'application/json' ,
        ...options.header
      },
    }
  }
  wxRequest (requestPayload) {
    return new Promise(async (resolve, reject) => {
      await axios({ ...requestPayload })
      .then(res => {
        if (res.status !== SUCCESS_STATUS) {
          groupConsole('error', requestPayload, res)
          reject(this.handleHTTPFailure(res))
        } else {
          this.handleResult(res, requestPayload, resolve, reject)
        }
      })
      .catch(res => {
        groupConsole('error', requestPayload, res)
        reject(this.handleWxFailure(res))
      })
    })
  }
  handleWxFailure (res) {
    // if (wx.network.isDisconnect()) {
    //   res.msg = '无网络，请检查网络状态'
    //   return res
    // } else {
      // res.msg = res.errMsg.split('fail')[1]
      // return res
    // }
  }
  handleHTTPFailure (res) {
    // if (/4\d{2}/.test(res.statusCode)) {
    //   res.msg = res.statusCode + ' 客户端请求有误'
    //   return res
    // } else if (/5\d{2}/.test(res.statusCode)) {
    //   res.msg = res.statusCode + ' 服务端内部错误'
    //   return res
    // } else {
    //   res.msg = res.statusCode + ' 连接失败，请稍后再试'
    //   return res
    // }
  }
  async handleResult (res, requestPayload, resolve, reject) {
    const { stat, data, msg } = res.data
    switch (stat) {
      case SUCCESS:
        groupConsole('info', requestPayload, res.data)
        resolve({ ...data, msg, stat })
        break
      // case AUTHORIZE:
      //   groupConsole('error', requestPayload, res.data)
      //   wx.navigateTo({ url: '/pages/login/index' })
      //   reject(res.data)
      //   break
      // case NO_BINDPHONE:
      //   wx.navigateTo({ url: '/pages/login/index?onlyBindPhone=true' })
      //   reject(resp)
      //   break
      // case AUTHORIZE_AND_BINDPHONE:
      //   wx.navigateTo({ url: '/pages/login/index?shouldBindPhone=true' })
      //   reject(resp)
      //   break
      // case ILLEAGAL_USER:
      //   wx.user.removeUserInfo()
      //   requestPayload.wx_uid = await wx.user.getWxUid()
      //   this.retry(res, requestPayload, resolve, reject)
      //   break
      default:
        groupConsole('error', requestPayload, res.data)
        reject(res.data)
    }
  }
}

export default new Fetch()